import { defineMessages } from 'react-intl';

const messages = defineMessages({
    customAdd: {
        defaultMessage: 'Add',
        description: 'Label for the add button for custom metadata',
        id: 'boxui.metadataInstanceFields.customAdd',
    },
    customRemove: {
        defaultMessage: 'Remove',
        description: 'Label for the remove button for custom metadata',
        id: 'boxui.metadataInstanceFields.customRemove',
    },
    invalidMetadataFieldType: {
        defaultMessage: 'Invalid metadata field type!',
        description: "Error message displayed if the template has an field type we don't recognize",
        id: 'boxui.metadataInstanceFields.invalidMetadataFieldType',
    },
    metadataFieldNoValue: {
        defaultMessage: 'No Value',
        description: 'Text to indicate no value exists',
        id: 'boxui.metadataInstanceFields.fieldNoValue',
    },
    metadataFieldSelectValue: {
        defaultMessage: 'Select Value',
        description: 'Text to indicate to select a value from drop down list',
        id: 'boxui.metadataInstanceFields.fieldSelectValue',
    },
    metadataFieldMultiSelectValue: {
        defaultMessage: 'Select Values',
        description: 'Text to indicate to select one or more values from dropdown list',
        id: 'boxui.metadataInstanceFields.fieldMultiSelectValue',
    },
    metadataFieldSetValue: {
        defaultMessage: 'Set Value',
        description: 'Text to indicate to set a value',
        id: 'boxui.metadataInstanceFields.fieldSetValue',
    },
    metadataFieldSetDate: {
        defaultMessage: 'Set Date',
        description: 'Text to indicate to set a date',
        id: 'boxui.metadataInstanceFields.fieldSetDate',
    },
});

export default messages;
